import React, { useEffect, useState, useRef } from 'react';
import { topBrands } from '../data/topBrandsData';
import { Link } from 'react-router-dom';
import '../style/TopBrandsSlider.css';

// ✅ CDN Base Path
const CDN_BASE = "https://cdn.greateastern.in/GETCO/TOP%20BRANDS/";

const TopBrandsSlider = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 6;
  const intervalRef = useRef(null);

  const getVisibleBrands = (start) => {
    const end = (start + visibleCount) % topBrands.length;
    if (end > start) {
      return topBrands.slice(start, end);
    } else {
      return [...topBrands.slice(start), ...topBrands.slice(0, end)];
    }
  };

  const [visibleBrands, setVisibleBrands] = useState(getVisibleBrands(0));

  const nextSlide = () => {
    const nextStart = (startIndex + 1) % topBrands.length;
    setVisibleBrands(getVisibleBrands(nextStart));
    setStartIndex(nextStart);
  };

  const prevSlide = () => {
    const prevStart = (startIndex - 1 + topBrands.length) % topBrands.length;
    setVisibleBrands(getVisibleBrands(prevStart));
    setStartIndex(prevStart);
  };

  useEffect(() => {
    intervalRef.current = setInterval(nextSlide, 2000);
    return () => clearInterval(intervalRef.current);
  }, [startIndex]);

  return (
    <div className="top-brands-slider-container">
      <h2 className="top-brands-slider-heading">Top Brands</h2>
      <div className="top-brands-slider-wrapper">
        <button className="top-brands-arrow left" onClick={prevSlide}>
          ‹
        </button>

        <div className="top-brands-slider">
          {visibleBrands.map((brand, idx) => {
            // ✅ Build CDN image URL
            const imgUrl = `${CDN_BASE}${brand.id}`;

            return (
              <div className="brand-cardd" key={idx}>
                {/* 🔥 Replaced Cloudinary <AdvancedImage> with <img> */}
                <img src={imgUrl} alt={brand.name} className="brand-logo" />
              </div>
            );
          })}
        </div>

        <button className="top-brands-arrow right" onClick={nextSlide}>
          ›
        </button>
      </div>

      <Link to="/topbrands" className="view-all-button">
        VIEW ALL
      </Link>
    </div>
  );
};

export default TopBrandsSlider;
